import type { ApolloLink } from '@apollo/client'
import { getCookie } from 'cookies-next'
import { cookieKeys } from 'lib/consts/browserStorage'
import { isImpersonationSession } from 'lib/helpers/isImpersonationSession/isImpersonationSession'
import {
  LoginPage_authProviderSignInName,
  LoginPage_signInName,
  LoginVerifyPage_signInWithTotpName,
} from 'gql/names/mutations'
import type { GqlOperationName } from 'gql/names/types'

const SIGN_IN_OPERATIONS: ReadonlySet<string> = new Set<GqlOperationName>([
  LoginPage_signInName,
  LoginPage_authProviderSignInName,
  LoginVerifyPage_signInWithTotpName,
])

export const getDeviceTokenHeaders = (operation: ApolloLink.Operation) => {
  const headers: Record<string, string> = {}

  const { operationName } = operation

  if (!operationName || !SIGN_IN_OPERATIONS.has(operationName)) {
    return headers
  }

  if (isImpersonationSession()) {
    return headers
  }

  const deviceToken = getCookie(cookieKeys.deviceToken)

  if (deviceToken) {
    headers['X-Device-Token'] = `${deviceToken}`
  }

  return headers
}
